export default {"src":"/hedera/_next/static/media/success.a92fe14c.svg","height":68,"width":68};